import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  doc,
  deleteDoc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { FaTrash } from "react-icons/fa";
import "../styles/Results.css";
import Pagination from "../components/Pagination";
import { Link } from "react-router-dom";


export default function SurveyResults() {
  const [entered, setEntered] = useState(false);
  const ADMIN_PASS = "admin-password123";

  const [surveys, setSurveys] = useState([]);
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [referralFilter, setReferralFilter] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const paginate = (pageNum) => setCurrentPage(pageNum);

  const types = [
    "مؤثر/مشهور محلي",
    "ممثل جمعية خيرية",
    "تاجر مهتم بالتعاون",
    "صاحب فود ترك",
    "من الأسر المنتجة",
    "أخرى",
  ];

  useEffect(() => {
    const q = query(
      collection(db, "survey_form"),
      orderBy("createdAt", "desc")
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSurveys(data);
      setFilteredSurveys(data);
    });
    return () => unsubscribe();
  }, []);

  const referralCodes = [
    ...new Set(surveys.map((s) => s.referral || "")),
  ].filter(Boolean);
  const cities = [...new Set(surveys.map((s) => s.city?.trim() || ""))].filter(
    Boolean
  );

  useEffect(() => {
    let data = [...surveys];

    if (searchTerm.trim()) {
      const term = searchTerm.trim().toLowerCase();
      data = data.filter(
        (s) =>
          (s.firstName && s.firstName.toLowerCase().includes(term)) ||
          (s.phone && s.phone.includes(term)) ||
          (s.email && s.email.toLowerCase().includes(term))
      );
    }
    if (referralFilter) {
      data = data.filter((s) => s.referral === referralFilter);
    }
    if (cityFilter) {
      data = data.filter((s) => s.city === cityFilter);
    }
    if (typeFilter) {
      data = data.filter((s) => (s.roles || []).includes(typeFilter));
    }
    if (dateFilter) {
      const start = new Date(dateFilter);
      start.setHours(0, 0, 0, 0);
      const end = new Date(dateFilter);
      end.setHours(23, 59, 59, 999);
      data = data.filter((s) => {
        if (!s.createdAt) return false;
        const d = s.createdAt.seconds
          ? new Date(s.createdAt.seconds * 1000)
          : new Date(s.createdAt);
        return d >= start && d <= end;
      });
    }
    setFilteredSurveys(data);
    setCurrentPage(1);
  }, [searchTerm, referralFilter, cityFilter, typeFilter, dateFilter, surveys]);

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredSurveys.slice(indexOfFirst, indexOfLast);

  const exportToExcel = () => {
    const data = filteredSurveys.map((s) => ({
      "الاسم الأول": s.firstName || "",
      "باقي الاسم": s.lastName || "",
      "رقم الجوال": s.phone || "",
      البريد: s.email || "",
      "المدينة/الحي": s.city || "",
      "أنواع التعاون": (s.roles || []).join(", "),
      أخرى: s.otherRole || "",
      "رسالة للإدارة": s.message || "",
      Referral: s.referral || "",
      التاريخ: s.createdAt
        ? new Date(s.createdAt.seconds * 1000).toLocaleString("ar-EG")
        : "",
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = { Sheets: { Data: worksheet }, SheetNames: ["Data"] };
    XLSX.writeFile(workbook, "survey_results.xlsx");
  };

  const handleDelete = async (id) => {
    const confirmation = await Swal.fire({
      title: "تأكيد الحذف",
      text: "هل أنت متأكد من حذف هذا السجل؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#7EBFE9",
      confirmButtonText: "نعم، احذف",
      cancelButtonText: "إلغاء",
    });
    if (confirmation.isConfirmed) {
      try {
        await deleteDoc(doc(db, "survey_form", id));
        Swal.fire("تم الحذف!", "تم حذف السجل بنجاح.", "success");
      } catch (e) {
        Swal.fire("خطأ!", "تعذر حذف السجل.", "error");
      }
    }
  };

  const totalPages = Math.ceil(filteredSurveys.length / recordsPerPage);

  if (!entered) {
    return (
      <div style={{ textAlign: "center", marginTop: "80px" }}>
        <h2>دخول الأدمن فقط</h2>
        <input
          type="password"
          placeholder="أدخل كلمة مرور الأدمن"
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.target.value === ADMIN_PASS)
              setEntered(true);
          }}
          style={{
            padding: 8,
            borderRadius: 4,
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        />
        <div style={{ color: "#aaa", marginTop: 8, fontSize: 13 }}>
          صفحة خاصة لإدارة متاجر الحي
        </div>
      </div>
    );
  }

  return (
    <div className="results-container" dir="rtl">
      <h1 className="results-title">نتائج متاجر الحي</h1>
      <div className="results-filters">
        <div className="filter-item">
          <label>بحث بالاسم/الجوال/البريد</label>
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="بحث..."
            autoComplete="off"
          />
        </div>
        <div className="filter-item">
          <label>المدينة/الحي</label>
          <select
            value={cityFilter}
            onChange={(e) => setCityFilter(e.target.value)}
          >
            <option value="">كل المدن</option>
            {cities.map((city, i) => (
              <option key={i} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-item">
          <label>نوع التعاون</label>
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
          >
            <option value="">كل الأنواع</option>
            {types.map((type, i) => (
              <option key={i} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-item">
          <label>رمز الإحالة</label>
          <select
            value={referralFilter}
            onChange={(e) => setReferralFilter(e.target.value)}
          >
            <option value="">كل الرموز</option>
            {referralCodes.map((ref, i) => (
              <option key={i} value={ref}>
                {ref}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-item">
          <label>تاريخ التسجيل</label>
          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
        </div>
        <div className="filter-item">
          <label>عدد النتائج</label>
          <select
            value={recordsPerPage}
            onChange={(e) => setRecordsPerPage(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        {/* شريط الأزرار: إدارة الإحالات (يسار) + تحميل إكسل (يمين) */}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "0.8rem",
            marginTop: "0.8rem",
          }}
        >
          {/* زر يفتح صفحة إدارة روابط الإحالة */}
          <Link
            to="/referrals"
            className="download-btn"
            title="إدارة وربط أكواد الإحالة بأصحابها"
            style={{
              textDecoration: "none",
              display: "inline-block",
              marginTop: 0,
            }}
          >
            إدارة روابط الإحالة
          </Link>

          {/* زر تحميل إكسل */}
          <button
            className="download-btn"
            onClick={exportToExcel}
            title="تنزيل النتائج المفلترة كملف Excel"
            style={{ marginTop: 0 }}
          >
            تحميل Excel
          </button>
        </div>
      </div>
      <div className="results-count">
        إجمالي الردود: {filteredSurveys.length}
      </div>

      <div className="table-responsive">
        <table className="results-table">
          <thead>
            <tr>
              <th>الاسم الأول</th>
              <th>باقي الاسم</th>
              <th>الجوال</th>
              <th>البريد</th>
              <th>المدينة/الحي</th>
              <th>أنواع التعاون</th>
              <th>أخرى</th>
              <th>رسالة للإدارة</th>
              <th>Referral</th>
              <th>التاريخ</th>
              <th>حذف</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.length ? (
              currentRecords.map((s) => (
                <tr key={s.id}>
                  <td>{s.firstName}</td>
                  <td>{s.lastName}</td>
                  <td>{s.phone}</td>
                  <td>{s.email}</td>
                  <td>{s.city}</td>
                  <td>{(s.roles || []).join(", ")}</td>
                  <td>{s.otherRole}</td>
                  <td style={{ maxWidth: 200, wordBreak: "break-word" }}>
                    {s.message}
                  </td>
                  <td>{s.referral}</td>
                  <td>
                    {s.createdAt
                      ? new Date(s.createdAt.seconds * 1000).toLocaleString(
                          "ar-EG"
                        )
                      : ""}
                  </td>
                  <td>
                    <button
                      className="delete-button"
                      onClick={() => handleDelete(s.id)}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center text-muted">
                  لا توجد نتائج مطابقة
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <Pagination
        recordsPerPage={recordsPerPage}
        totalRecords={filteredSurveys.length}
        currentPage={currentPage}
        paginate={paginate}
      />
    </div>
  );
}
